import { createRouter, createWebHistory } from 'vue-router'

import AdminApiClientsIndex from './pages/admin/api_clients/index/index.vue'
import AdminApiClientsNew from './pages/admin/api_clients/new/index.vue'
import AdminApiClientsEdit from './pages/admin/api_clients/edit/index.vue'
import AdminExportFormatsIndex from './pages/admin/export_formats/index/index.vue'
import AdminExportFormatsNew from './pages/admin/export_formats/new/index.vue'
import AdminExportFormatsEdit from './pages/admin/export_formats/edit/index.vue'
import AdminPublicationsIndex from './pages/admin/publications/index/index.vue'
import AdminPublicationsShow from './pages/admin/publications/show/index.vue'
import AdminPublicationsNew from './pages/admin/publications/new/index.vue'
import AdminPublicationsEdit from './pages/admin/publications/edit/index.vue'
import AdminSectionsIndex from './pages/admin/sections/index/index.vue'
import AdminSectionsNew from './pages/admin/sections/new/index.vue'
import AdminSectionsEdit from './pages/admin/sections/edit/index.vue'
import AdminSqueueIndex from './pages/admin/squeues/index/index.vue'
import AdminSqueueNew from './pages/admin/squeues/new/index.vue'
import AdminSqueueEdit from './pages/admin/squeues/edit/index.vue'
import AdminStyleMapIndex from './pages/admin/style_maps/index.vue'
import AdminStyleMapEdit from './pages/admin/style_maps/edit.vue'
import AdminTransformIndex from './pages/admin/transforms/index/index.vue'
import AdminTransformNew from './pages/admin/transforms/new/index.vue'
import AdminTransformEdit from './pages/admin/transforms/edit/index.vue'
import AdminUsersIndex from './pages/admin/users/index/index.vue'
import AdminUsersShow from './pages/admin/users/show/index.vue'
import AdminUsersNew from './pages/admin/users/new/index.vue'
import AdminUsersEdit from './pages/admin/users/edit/index.vue'
import AdminWebCategoriesIndex from './components/admin/web_categories/index.vue'
import IssuesIndex from './pages/issues/index/index.vue'
import IssueShow from './pages/issues/show/index.vue'
import IssueNew from './pages/issues/new/index.vue'
import IssueClone from './pages/issues/clone/index.vue'
import IssueEdit from './pages/issues/edit/index.vue'
import MediaIndex from './pages/media/index/index.vue'
import PageShow from './pages/pages/show/index.vue'
import StoriesIndex from './pages/stories/index/index.vue'
import StoryForm from './components/stories/form/story_form.vue'
import StorySavedSearches from './pages/story_saved_searches/index.vue'
import StoryShow from './pages/stories/show/index.vue'
import LocationsIndex from './pages/locations/index/index.vue'
import LocationsNew from './pages/locations/new/index.vue'
import LocationsEdit from './pages/locations/edit/index.vue'
import LocationsShow from './pages/locations/show/index.vue'
import UserEdit from './pages/user/edit/index.vue'

const routes = [
  {
    path: '/admin/export_formats',
    name: 'adminExportFormats',
    component: AdminExportFormatsIndex
  },
  {
    path: '/admin/export_formats/new',
    name: 'newAdminExportFormat',
    component: AdminExportFormatsNew
  },
  {
    path: '/admin/export_formats/:exportFormatId/edit',
    name: 'editAdminExportFormat',
    component: AdminExportFormatsEdit,
    props: ({ params: { exportFormatId } }) => ({ exportFormatId: Number(exportFormatId) })
  },
  {
    path: '/admin/api_clients',
    name: 'adminApiClients',
    component: AdminApiClientsIndex
  },
  {
    path: '/admin/api_clients/new',
    name: 'newAdminApiClients',
    component: AdminApiClientsNew
  },
  {
    path: '/admin/api_clients/:apiClientId/edit',
    name: 'editAdminApiClients',
    component: AdminApiClientsEdit,
    props: ({ params: { apiClientId } }) => ({ apiClientId: Number(apiClientId) })
  },
  {
    path: '/admin/publications',
    name: 'adminPublications',
    component: AdminPublicationsIndex
  },
  {
    path: '/admin/publications/new',
    name: 'newAdminPublications',
    component: AdminPublicationsNew
  },
  {
    path: '/admin/publications/:publicationId/edit',
    name: 'editAdminPublication',
    component: AdminPublicationsEdit,
    props: ({ params: { publicationId } }) => ({ publicationId: Number(publicationId) })
  },
  {
    path: '/admin/publications/:publicationId',
    name: 'adminPublication',
    component: AdminPublicationsShow,
    props: ({ params: { publicationId } }) => ({ publicationId: Number(publicationId) })
  },
  {
    path: '/admin/sections',
    name: 'adminSections',
    component: AdminSectionsIndex
  },
  {
    path: '/admin/sections/new',
    name: 'newAdminSection',
    component: AdminSectionsNew
  },
  {
    path: '/admin/sections/:sectionId/edit',
    name: 'editAdminSection',
    component: AdminSectionsEdit,
    props: ({ params: { sectionId } }) => ({ sectionId: Number(sectionId) })
  },
  {
    path: '/admin/squeues',
    name: 'adminSqueues',
    component: AdminSqueueIndex
  },
  {
    path: '/admin/squeues/new',
    name: 'newAdminSqueues',
    component: AdminSqueueNew
  },
  {
    path: '/admin/squeues/:squeueId/edit',
    name: 'editAdminSqueues',
    component: AdminSqueueEdit,
    props: ({ params: { squeueId } }) => ({ squeueId: Number(squeueId) })
  },
  {
    path: '/admin/style_maps',
    name: 'adminStyleMaps',
    component: AdminStyleMapIndex
  },
  {
    path: '/admin/style_maps/:styleMapId/edit',
    name: 'editAdminStyleMap',
    component: AdminStyleMapEdit,
    props: ({ params: { styleMapId } }) => ({ styleMapId: Number(styleMapId) })
  },
  {
    path: '/admin/transforms',
    name: 'adminTransforms',
    component: AdminTransformIndex
  },
  {
    path: '/admin/transforms/new',
    name: 'newAdminTransform',
    component: AdminTransformNew
  },
  {
    path: '/admin/transforms/:transformId/edit',
    name: 'editAdminTransform',
    component: AdminTransformEdit,
    props: ({ params: { transformId } }) => ({ transformId: Number(transformId) })
  },
  {
    path: '/admin/users',
    name: 'adminUsers',
    component: AdminUsersIndex
  },
  {
    path: '/admin/users/new',
    name: 'newAdminUser',
    component: AdminUsersNew
  },
  {
    path: '/admin/users/:userId/edit',
    name: 'editAdminUser',
    component: AdminUsersEdit,
    props: ({ params: { userId } }) => ({ userId: Number(userId) })
  },
  {
    path: '/admin/users/:userId',
    name: 'adminUser',
    component: AdminUsersShow,
    props: ({ params: { userId } }) => ({ userId: Number(userId) })
  },
  {
    path: '/admin/web_categories',
    name: 'adminWebCategories',
    component: AdminWebCategoriesIndex
  },
  {
    path: '/issues/new',
    name: 'newIssue',
    component: IssueNew
  },
  {
    path: '/issues/:issueId/clone',
    name: 'cloneIssue',
    component: IssueClone,
    props: ({ params: { issueId } }) => ({ issueId: Number(issueId) })
  },
  {
    path: '/issues/:issueId/edit',
    name: 'editIssue',
    component: IssueEdit,
    props: ({ params: { issueId } }) => ({ issueId: Number(issueId) })
  },
  {
    path: '/issues/:issueId',
    name: 'issue',
    component: IssueShow,
    props: ({ params: { issueId } }) => ({ issueId: Number(issueId) })
  },
  {
    path: '/issues/:issueId/pages/:pageId',
    name: 'issuePage',
    component: PageShow,
    props: ({ params: { issueId, pageId } }) => ({
      issueId: Number(issueId),
      pageId: Number(pageId)
    })
  },
  {
    path: '/issues',
    name: 'issues',
    component: IssuesIndex
  },
  {
    path: '/issues/:issueId/stories/:storyId/edit',
    name: 'editIssueStory',
    component: StoryForm,
    props: ({ params: { issueId, storyId } }) => ({
      issueId: Number(issueId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/issues/:issueId/stories/:storyId',
    name: 'issueStory',
    component: StoryShow,
    props: ({ params: { issueId, storyId } }) => ({
      issueId: Number(issueId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/issues/:issueId/pages/:pageId/stories/:storyId/edit',
    name: 'editPageStory',
    component: StoryForm,
    props: ({ params: { issueId, pageId, storyId } }) => ({
      issueId: Number(issueId),
      pageId: Number(pageId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/issues/:issueId/pages/:pageId/stories/:storyId',
    name: 'pageStory',
    component: StoryShow,
    props: ({ params: { issueId, storyId } }) => ({
      issueId: Number(issueId),
      storyId: Number(storyId)
    })
  },
  {
    path: '/media',
    name: 'media',
    component: MediaIndex
  },
  {
    path: '/stories',
    name: 'stories',
    component: StoriesIndex
  },
  {
    path: '/stories/:storyId',
    name: 'story',
    component: StoryShow,
    props: ({ params: { storyId } }) => ({ storyId: Number(storyId) })
  },
  {
    path: '/stories/:storyId/edit',
    name: 'editStory',
    component: StoryForm,
    props: ({ params: { storyId } }) => ({ storyId: Number(storyId) })
  },
  {
    path: '/story_saved_searches',
    name: 'storySavedSearches',
    component: StorySavedSearches,
  },
  {
    path: '/locations',
    name: 'locations',
    component: LocationsIndex
  },
  {
    path: '/locations/new',
    name: 'newLocation',
    component: LocationsNew
  },
  {
    path: '/locations/:locationId/edit',
    name: 'editLocation',
    component: LocationsEdit,
    props: ({ params: { locationId } }) => ({ locationId: Number(locationId) })
  },
  {
    path: '/locations/:locationId',
    name: 'showLocation',
    component: LocationsShow,
    props: ({ params: { locationId } }) => ({ locationId: Number(locationId) })
  },
  {
    path: '/user/edit',
    name: 'editUser',
    component: UserEdit
  },
  {
    path: '/',
    component: StoriesIndex
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { el: to.hash }
    } else {
      return { top: 0 }
    }
  }
})

export default router
